export default {
  searchPlaceholder: {
    id: 'SEARCH-IMPUT_PLACEHOLDER',
    defaultMessage: 'Search within results',
    description: 'Default placeholder text when no query has been entered',
  },
};
